import React, { useEffect, createElement } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionVisualization } from '../components/SolutionVisualization';
import { ProductPresentation } from '../components/ProductPresentation';
import { BonusesSection } from '../components/BonusesSection';
import { AudienceSection } from '../components/AudienceSection';
import { AnalogySection } from '../components/AnalogySection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
// Declare fbq type for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    // Initialize fbq function
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
    }
    // Load Meta Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize Meta Pixel after script loads
    script.onload = () => {
      if (window.fbq) {
        window.fbq('init', '1943292123286339');
        window.fbq('track', 'PageView');
      }
    };
    // Fallback: Initialize immediately if script is already loaded
    if (window.fbq && window.fbq.loaded) {
      window.fbq('init', '1943292123286339');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-amber-200 selection:text-amber-900" data-id="element-269">
      <Header data-id="element-270" />
      <main data-id="element-271">
        <HeroSection data-id="element-272" />
        <ProblemSection data-id="element-273" />
        <SolutionVisualization data-id="element-274" />
        <ProductPresentation data-id="element-275" />
        <BonusesSection data-id="element-276" />
        <AudienceSection data-id="element-277" />
        <AnalogySection data-id="element-278" />
        <PricingSection data-id="element-279" />
        <FinalCTA data-id="element-280" />
      </main>
      <Footer data-id="element-281" />

      {/* Sales notification - mobile only */}
      <SalesNotification data-id="element-282" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-283">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1943292123286339&ev=PageView&noscript=1" alt="" data-id="element-284" />
      </noscript>
    </div>;
}